"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import { usePlaygroundMobileLayout } from "#/features/playground/hooks/usePlaygroundMobileLayout";
import { selectIsInitialized } from "#/features/project/model/projectSlice";
import { usePlaygroundRoute } from "#/shared/hooks/usePlaygroundRoute";
import { prefetchSplitPanelsLayout } from "#/shared/ui/templates/SplitPanelsLayout/prefetchSplitPanelsLayout";
import { useAppSelector } from "#/store/hooks";

/**
 * True when playground panel content can replace the route/panel skeleton
 * without a visible layout jump (split layout chunk loaded + project initialized).
 */
export const usePlaygroundPanelsReady = () => {
  const $ = _c(3);
  const isMobile = usePlaygroundMobileLayout();
  const isInitialized = useAppSelector(selectIsInitialized);
  const route = usePlaygroundRoute();
  const projectSlug = route?.slug[0] ?? "";
  const [splitLayoutReady, setSplitLayoutReady] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isMobile) {
    t0 = () => {
      if (isMobile) {
        return;
      }
      let cancelled = false;
      prefetchSplitPanelsLayout().then(() => {
        if (!cancelled) {
          setSplitLayoutReady(true);
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t1 = [isMobile];
    $[0] = isMobile;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  bb0: {
    if (!route) {
      t2 = false;
      break bb0;
    }
    if (isMobile) {
      if (!projectSlug) {
        t2 = true;
        break bb0;
      }
      t2 = isInitialized;
      break bb0;
    }
    if (!splitLayoutReady || !projectSlug) {
      t2 = false;
      break bb0;
    }
    t2 = isInitialized;
  }
  return t2;
};